import { CMSObject } from '../../../../tw/models/__CMSObject'
import React, { useMemo } from 'react'
import Button from '@mui/material/Button'
import { ReactComponent as DownloadIcon } from '../../../../assets/images/card/actions/download-icon.svg'
import { disableButton } from './utils'
import { Messages } from '../../../../utils/messages'
import { fi } from '../../../../utils/helpers'

const DownloadButton = ({
	item,
	icon = <DownloadIcon />
}: {
	item: CMSObject
	icon?: React.ReactNode
}) => {
	const disableAction = useMemo(() => {
		return disableButton(item)
	}, [item])

	return (
		<span
			className="card-action"
			title={fi(disableAction, Messages.FeatureNotAvailable, 'Download')}
		>
			<Button
				data-testid="dwd-btn"
				color="primary"
				variant="text"
				size="large"
				onClick={() => item.download()}
				disabled={disableAction}
			>
				{icon}
			</Button>
		</span>
	)
}

export default DownloadButton
